import { useTitle } from "@/Utilities/Hooks";
import PlanBlock from "@/Components/Blocks/PlanBlock";
import TextBlock from "@/Components/Blocks/TextBlock";
import ContactPersons from "@/Components/Blocks/ContactPersons";
import HomeLayout from "@/Layouts/HomeLayout";
import { Subheader } from "@/Components";
import React, { useState } from "react";
import CreateYourAccount from "@/Pages/Home/deprecated/Partials/CreateYourAccount";
import { PLAN_DATA } from "@/Enums/plans";

const Plans = ({ errors }) => {
  useTitle("Plans");

  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <div className="plans-block relative"></div>
      <div className="bg-background pb-8 pt-8 md:bg-white md:pt-16">
        {PLAN_DATA.map((plan, index) => (
          <PlanBlock
            key={index}
            plan={plan}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
          />
        ))}

        <TextBlock
          className="z-10 bg-background md:bg-white md:pb-24 md:pt-10"
          pos="flex-col"
        >
          <div className="self-start">
            <Subheader className="font-normal">
              CONTACT US FOR QUESTIONS OR PRICING
            </Subheader>
          </div>

          <ContactPersons />
        </TextBlock>

        <CreateYourAccount
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          errors={errors}
        />
      </div>
    </>
  );
};

Plans.layout = (page) => <HomeLayout>{page}</HomeLayout>;

export default Plans;
